import type { FC } from "react";

/**
 * Discriminated union of client action types.
 * Mirrors the Python ClientAction type on the backend.
 * Grows as new action types are added.
 */
export interface FollowupQuestionsAction {
  type: "followup_questions";
  is_enabled: boolean;
}

export type ClientAction = FollowupQuestionsAction;

const isFollowupQuestionsAction = (
  value: unknown
): value is FollowupQuestionsAction => {
  if (typeof value !== "object" || value === null) return false;

  const candidate = value as Record<string, unknown>;

  return (
    candidate.type === "followup_questions" &&
    typeof candidate.is_enabled === "boolean"
  );
};

export const isClientAction = (value: unknown): value is ClientAction =>
  isFollowupQuestionsAction(value);

export interface ActionHandlerProps {
  action: ClientAction;
}

export type ActionHandlerComponent = FC<ActionHandlerProps>;
